import React from 'react';
import SharedInsuranceForm from '../InsuranceForm';
import SharedInsurerDocsUploadField from '../InsurerDocsUploadField';
import { CARRIER_INSURANCE_DOCUMENTS_UPLOAD_URL } from '@/config';

const CarrierInsuranceForm: React.FC<{ open?: any }> = ({ open }) => {
  const CarrierInsurerDocsUpload = () => (
    <SharedInsurerDocsUploadField 
      uploadUrl={CARRIER_INSURANCE_DOCUMENTS_UPLOAD_URL}
      borderStyle="1.5px"
      iconSize={32}
      typographyVariant="body2"
      listItemStyles={{
        pb: 0,
        pt: 0,
        avatarMinWidth: '43px',
        avatarWidth: 32,
        avatarHeight: 32
      }}
    />
  );

  return <SharedInsuranceForm open={open} InsurerDocsUploadComponent={CarrierInsurerDocsUpload} />;
};

export default CarrierInsuranceForm;
